<template>
  <div class=" mr-0 ml-1 ml-md-0 ml-lg-1 ml-xl-1  mr-lg-3 mr-xl-7 px-0">
    <span class="text-body-1 text-lg-body-2 font-weight-bold mx-0  px-0"> {{lecture.monthYear|dateEU('MMMM   YYYY')}}</span>
    <p v-if="bo">{{ lecture }}
            <section v-if="publication.type!=6" >
                <v-btn v-if="publication.type!=7"
                    x-small class="mt-0 ml-2 white--text" color="green darken-4"
                    :to="{name:'publication.bo.edit',params: { type:8, id:lecture.id }}" >
                    edit
                </v-btn>
                <v-btn
                    x-small class="mt-0 ml-2 white--text" color="red darken-4"
                    :to="{name:'publication.bo.delete',params: { type:8, id:lecture.id }}" >
                    delete
                </v-btn>
            </section>
    </p>
  </div>
</template>
<script>

export default {
  props: {
        bo: {type:Boolean,
            default:false
        },
        lecture:{},
        icon:null
      }
}
</script>




